module.exports = __webpack_public_path__ + "static/media/img_give_back@3x.6785d7af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_give_back@3x.jpg
// module id = 812
// module chunks = 0